import { withAlertHandler, formatCurrency, offerTypes } from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import OfferActionDialog from '../../OfferActionDialog';
import PaymentProcessDialog from './PaymentProcessDialog';
import PaymentProcessForm from './PaymentProcessForm';
import {
  submitInvestmentMutation,
  cancelInvestmentMutation,
  offerInvestmentsQuery,
} from '../../../../apollo';
import { ACH_MAX_LIMIT, CARD_MAX_LIMIT } from '../../../../config';

class PaymentProcessAction extends Component {
  constructor(props) {
    super(props);
    const {
      setPaymentSteps,
      investorUser,
      investmentId,
      showPaymentMethodStep,
      showbrokerageAgreementStep,
      showAgreementStep,
    } = props;
    const INVESTMENT_STEPS = {
      detailStep: 0,
      brokerageStep: 5,
      subscriptionStep: 4,
    };

    const showAgreementCheck = showbrokerageAgreementStep
      ? INVESTMENT_STEPS.brokerageStep
      : INVESTMENT_STEPS.subscriptionStep;
    const isStripeStep = showPaymentMethodStep;

    if (isStripeStep) {
      this.state = {
        activeStep: isStripeStep
          ? setPaymentSteps
          : INVESTMENT_STEPS.detailStep,
        cancel: false,
        investmentId,
        investorUser,
      };
    } else {
      this.state = {
        cancel: false,
        activeStep: showAgreementStep
          ? showAgreementCheck
          : INVESTMENT_STEPS.detailStep,
        investmentId,
        investorUser,
      };
    }
  }
  toggleCancelDialog = () => {
    const { cancel } = this.state;
    this.setState({ cancel: !cancel });
  };

  validate = (values) => {
    const { offer, investorUser } = this.props;
    const notificationsLimit = (message, limit) => {
      return (
        <div className='limit-info-container error_limit'>
          <svg
            class='MuiSvgIcon-root-75'
            focusable='false'
            viewBox='0 0 24 24'
            aria-hidden='true'
          >
            <path d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'></path>
          </svg>
          <p className='limit-text-info'>
            <span>{message}</span> {formatCurrency(limit)}
          </p>
        </div>
      );
    };

    const errors = {};
    if (!values.paymentMethod) {
      errors.paymentMethod = 'Required';
    }
    if (!values.paymentType) {
      errors.paymentType = 'Payment Type Required';
    }
    if (!values.crowdfundingAmount) {
      errors.crowdfundingAmount = 'Required';
    }
    if (!values.crowdfundingQuestion) {
      errors.crowdfundingQuestion = 'Required';
    }
    if (!values.investmentAmount) {
      errors.investmentAmount = 'Required';
    } else if (values.investmentAmount < offer.minimumInvestment) {
      errors.investmentAmount = notificationsLimit(
        'Does not meet minimum of',
        offer.minimumInvestment
      );
    } else if (
      values.investmentAmount > 999999.99 &&
      values.paymentType === 'BANK_WIRE'
    ) {
      errors.investmentAmount = notificationsLimit(
        'Exceeds maximum Card limit of',
        +CARD_MAX_LIMIT
      );
    } else if (
      values.investmentAmount > 6000 &&
      values.paymentType === 'BANK_ACH'
    ) {
      errors.investmentAmount = notificationsLimit(
        'Exceeds maximum ACH limit of ',
        +ACH_MAX_LIMIT
      );
    } else if (
      offer.typeOfOffer === 'REG_CF' &&
      investorUser.selectedOptionTypes !== 'YES' &&
      values.investmentAmount > 107000
    ) {
      errors.investmentAmount = notificationsLimit(
        'You cannot invest more than',
        107000
      );
    } else if (offer.typeOfOffer == 'REG_A') {
      if (!values.income) {
        errors.income = 'Required';
      } else if (!values.networth) {
        errors.networth = 'Required';
      }
      const limitations =
        (Math.max(Number(values.networth), Number(values.income)) * 10) / 100;
      if (
        values.investmentAmount > limitations &&
        this.state.investorUser.selectedOptionTypes !== 'YES'
      ) {
        if (limitations == 0) {
          errors.income = 'Required';
          errors.networth = 'Required';
        } else {
          errors.investmentAmount = notificationsLimit(
            `Your ${offerTypes.getLabel(
              offer.typeOfOffer
            )} investment limit:  `,
            limitations
          );
        }
      }
    }
    if (
      offer.typeOfOffer == 'REG_CF' &&
      investorUser.selectedOptionTypes !== 'YES'
    ) {
      if (values.networth < '107000' || values.income < '107000') {
        const limitations =
          (Math.max(Number(values.networth), Number(values.income)) * 5) / 100;
        if (values.investmentAmount > limitations) {
          if (limitations == 0) {
            errors.income = 'Required';
            errors.networth = 'Required';
          } else if (values.investmentAmount < 2200) {
            errors.investmentAmount = notificationsLimit(
              `Your combined annual investment limit for ${offerTypes.getLabel(
                offer.typeOfOffer
              )} Offer, starts at a minimum of `,
              2200
            );
          } else {
            errors.investmentAmount = notificationsLimit(
              `Your ${offerTypes.getLabel(
                offer.typeOfOffer
              )} investment limit:  `,
              limitations
            );
          }
        }
      } else if (values.networth > '107000' && values.income > '107000') {
        const limitations =
          (Math.max(Number(values.networth), Number(values.income)) * 10) / 100;
        if (values.investmentAmount > limitations) {
          if (limitations == 0) {
            errors.income = 'Required';
            errors.networth = 'Required';
          } else if (values.investmentAmount > 107000) {
            errors.investmentAmount = notificationsLimit(
              `Your ${offerTypes.getLabel(
                offer.typeOfOffer
              )} investment limit 10% : `,
              limitations
            );
          }
        }
      }
    }
    if (values.subscriptionAgreementStatus !== 'SIGNED') {
      errors.subscriptionAgreementStatus = 'You have documents to sign.';
      if (values.subscriptionAgreementStatus === 'DECLINED') {
        errors.subscriptionAgreementStatus = 'You have declined to sign.';
      }
    }
    if (values.brokerageAgreementStatus !== 'SIGNED') {
      errors.brokerageAgreementStatus = 'You have documents to sign.';
      if (values.brokerageAgreementStatus === 'DECLINED') {
        errors.brokerageAgreementStatus = 'You have declined to sign.';
      }
    }

    if (values.paymentMethod === 'CRYPTO' && !values.transactionId) {
      errors.transactionId = 'Required';
    }
    if (!values.paymentSent) {
      errors.paymentSent = 'Required';
    }

    return errors;
  };

  handleStep = (index) => () => {
    if (index < this.state.activeStep) {
      this.setState({
        activeStep: index,
      });
    }
  };

  update = async (variables) => {
    const { activeStep } = this.state;

    const {
      offer,
      handleSnackbarError,
      client: { mutate },
      handleClose,
    } = this.props;

    const stepByOffer =
      offer.typeOfOffer === 'REG_CF' || offer.typeOfOffer === 'REG_A' ? 8 : 6;

    if (activeStep === stepByOffer) {
      handleClose();
    } else {
      let investmentStatus = 'IN_PROGRESS';

      if (variables.paymentSent) {
        investmentStatus = 'PENDING_PAYMENT_VERIFICATION';

        if (!variables.receiptImageId) {
          investmentStatus = 'PENDING_TRANSACTION_RECEIPT';
        }

        if (variables.paymentMethod === 'CRYPTO' && !variables.walletAddress) {
          investmentStatus = 'PENDING_WALLET_ADDRESS';
        }
      }

      if (variables.investmentStatus === 'INVESTMENT_COMPLETE') {
        investmentStatus = 'INVESTMENT_COMPLETE';
      }

      const input = {
        ...variables,
        investmentStatus,
        offerId: offer._id,
      };

      try {
        const refetchQueries = [
          {
            query: offerInvestmentsQuery,
            variables: {
              offerId: offer._id,
            },
          },
        ];

        const {
          data: { submitInvestment },
        } = await mutate({
          mutation: submitInvestmentMutation,
          variables: { input },
          refetchQueries,
        });

        this.setState({
          investmentId: submitInvestment._id,
          activeStep: this.state.activeStep + 1,
        });
      } catch (error) {
        handleSnackbarError(error);
      }
    }
  };

  remove = async () => {
    const {
      setSnackbarMessage,
      handleSnackbarError,
      handleClose,
      offer,
      client: { mutate },
    } = this.props;
    const { investmentId } = this.state;

    if (!investmentId) {
      this.toggleCancelDialog();
      handleClose();

      setSnackbarMessage('Investment canceled');
    } else {
      try {
        const refetchQueries = [
          {
            query: offerInvestmentsQuery,
            variables: {
              offerId: offer._id,
            },
          },
        ];

        const { data } = await mutate({
          mutation: cancelInvestmentMutation,
          variables: { investmentId },
          refetchQueries,
        });

        if (data) {
          this.toggleCancelDialog();
          handleClose();
          setSnackbarMessage('Investment canceled');
        }
      } catch (error) {
        handleSnackbarError(error);
      }
    }
  };

  render() {
    const { open, handleClickOpen, handleClose, title, offer } = this.props;

    const { cancel, activeStep, investmentId, investorUser } = this.state;

    return (
      <Fragment>
        <PaymentProcessDialog
          open={open}
          handleClose={handleClose}
          dialogBody={
            <PaymentProcessForm
              handleClose={handleClose}
              toggleCancelDialog={this.toggleCancelDialog}
              offer={offer}
              investmentId={investmentId}
              update={this.update}
              activeStep={activeStep}
              handleStep={this.handleStep}
              validate={this.validate}
              investorUser={investorUser}
            />
          }
        />
        {title && (
          <button
            onClick={handleClickOpen}
            className='button small w-button'
            style={{ width: 'inherit' }}
          >
            {title}
          </button>
        )}
        <OfferActionDialog
          open={cancel}
          handleClose={this.toggleCancelDialog}
          request={this.remove}
          title='Cancel Transaction'
          dialogBody='This will delete all entered information and cannot be undone.'
          enableMessage={false}
          submitText='Confirm'
        />
      </Fragment>
    );
  }
}

PaymentProcessAction.propTypes = {
  title: PropTypes.string,
  investmentId: PropTypes.string,
  offer: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleClickOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  investorUser: PropTypes.object,
};

PaymentProcessAction.defaultProps = {
  title: null,
  investmentId: null,
  showAgreementStep: false,
  investorUser: null,
  handleClickOpen: null,
};

export default connect()(withApollo(withAlertHandler(PaymentProcessAction)));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessAction.js